import { BranchEditForm } from "./EditBranch";
import { hasUserPermission } from "../utils/userPermissions";
import CreateRecordModal from '../components/CreateRecordModal';
import PermissionGate from '../components/PermissionGate';
import React, { useState } from "react";
import { Alert, Button } from '@themesberg/react-bootstrap';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCodeBranch, faCheckCircle } from "@fortawesome/free-solid-svg-icons";
import { PageBranchTable } from "../components/Tables";
import ListingViewToggle from "../components/ListingViewToggle";
import { BranchForm } from "./CreateBranch";
import { Link } from 'react-router-dom';

export default () => {
  const [viewMode, setViewMode] = useState("grid");
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [isCreating, setIsCreating] = useState(false);
  const [editingBranchId, setEditingBranchId] = useState(null);
  const [isUpdating, setIsUpdating] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);
  const [successMessage, setSuccessMessage] = useState("");

  const loggedInAdmin = JSON.parse(sessionStorage.getItem('quoteadmin'));
  const isLoggedInSuperOrAdmin = loggedInAdmin?.role_name === "Admin" || loggedInAdmin?.role_name === "Super Admin" || loggedInAdmin?.role_name === "Internal Sales";

  const closeCreateModal = () => {
    if (!isCreating) setShowCreateModal(false);
  };

  const handleBranchCreated = (result) => {
    setShowCreateModal(false);
    setSuccessMessage(result.message || 'Branch created successfully.');
    setRefreshKey(value => value + 1);
  };

  const openEditModal = id => {
    if (!hasUserPermission("branches", "edit")) return;
    setSuccessMessage("");
    setEditingBranchId(id);
  };

  const closeEditModal = () => {
    if (!isUpdating) setEditingBranchId(null);
  };

  const handleBranchUpdated = result => {
    setEditingBranchId(null);
    setSuccessMessage(result.message || "Branch updated successfully.");
    setRefreshKey(value => value + 1);
  };

  return (
    <>
      <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-3">
        <div className="my-auto">
          <h2 className="page-breadcrumb">Branches</h2>
        </div>
        <div className="d-flex align-items-center flex-wrap gap-2">
          <ListingViewToggle viewMode={viewMode} onChange={setViewMode} />
          <PermissionGate module="branches" action="add"><Button
            variant="primary"
            className="btn-quote-blue d-inline-flex align-items-center py-2 px-3 box-shedow-none outline-none"
            onClick={() => { setSuccessMessage(""); setShowCreateModal(true); }}
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-plus-circle me-1">
              <circle cx="12" cy="12" r="10"></circle>
              <line x1="12" y1="8" x2="12" y2="16"></line>
              <line x1="8" y1="12" x2="16" y2="12"></line>
            </svg>
            Create Branch
          </Button></PermissionGate>
          {isLoggedInSuperOrAdmin && (
            <Link to="/bdeleted">
              <Button variant="outline-secondary" className="ms-2 py-2 px-3">
                Deleted Records
              </Button>
            </Link>
          )}
        </div>
      </div>

      {successMessage && (
        <Alert variant="success" dismissible onClose={() => setSuccessMessage("")} className="d-flex align-items-center gap-2">
          <FontAwesomeIcon icon={faCheckCircle} />
          <span>{successMessage}</span>
        </Alert>
      )}

      <div className="my-auto">
        <PageBranchTable viewMode={viewMode} refreshKey={refreshKey} onEditBranch={openEditModal} />
      </div>

      <CreateRecordModal
        show={showCreateModal}
        onHide={closeCreateModal}
        isSubmitting={isCreating}
        titleId="create-branch-title"
        title="Create Branch"
        description="Add a branch and connect it to your company."
        icon={faCodeBranch}
        size="lg"
      >
        {showCreateModal && (
          <BranchForm
            onSuccess={handleBranchCreated}
            onCancel={closeCreateModal}
            onSubmittingChange={setIsCreating}
          />
        )}
      </CreateRecordModal>

      <CreateRecordModal
        show={editingBranchId !== null}
        onHide={closeEditModal}
        isSubmitting={isUpdating}
        titleId="edit-branch-title"
        title="Edit Branch"
        description="Update branch details and company assignments."
        icon={faCodeBranch}
        size="lg"
      >
        {editingBranchId !== null && (
          <BranchEditForm key={editingBranchId} branchId={editingBranchId}
            onSuccess={handleBranchUpdated} onCancel={closeEditModal} onSubmittingChange={setIsUpdating} />
        )}
      </CreateRecordModal>
    </>
  );
};
